import { useEffect, type FC } from 'react';
import EligibilityWidgetCard from './components/EligibilityWidgetCard';
import EligibilityWidgetForm from './components/EligibilityWidgetForm';
import useEligibilityWidget from './hooks/useEligibilityWidget';
import EligibilityWidgetToken from './components/EligibilityWidgetToken';
import EligibilityWidgetLoading from './components/EligibilityWidgetLoading';
import useCurrentLanguage from '../states/language/useCurrentLanguage';
import getLanguageByCode from '../states/language/getLanguageByCode';

export interface EligibilityWidgetProps {
  pid: string;
  apiKey: string;
  language: string;
}

const EligibilityWidget: FC<EligibilityWidgetProps> = ({ pid, apiKey, language }) => {
  const {
    actions: { setPid, setApiKey, autoSubmit },
    states: { showForm, loading, textKeysLoaded },
    selectors: { getEligibilityWidgetTokenProps, getEligibilityWidgetFormProps },
  } = useEligibilityWidget();
  const { changeLanguageAndTranslation } = useCurrentLanguage().actions;

  /**
   * Set @pid && @apiKey in the global store (reactiveVar)
   */
  useEffect(() => {
    setPid(pid);
    setApiKey(apiKey);
  }, [pid, apiKey]);

  useEffect(() => {
    changeLanguageAndTranslation(getLanguageByCode(language), pid);
  }, [language]);

  /**
   * Auto submit form if override is detected
   * Check @detectOverrideMode in @useEligibilityWidget for more details
   */
  useEffect(() => {
    autoSubmit();
  }, []);

  if (!textKeysLoaded) return null;

  if (loading) return <EligibilityWidgetLoading />;

  return (
    <EligibilityWidgetCard>
      {showForm ? (
        <EligibilityWidgetForm {...getEligibilityWidgetFormProps()} />
      ) : (
        <EligibilityWidgetToken {...getEligibilityWidgetTokenProps()} />
      )}
    </EligibilityWidgetCard>
  );
};

export default EligibilityWidget;
